export default "__VITE_ASSET__BRMnV38Z__"